




























import { Component, Prop, Vue } from "vue-property-decorator";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import IndividualTaxationService from "@/services/request/IndividualTaxationService";
import UploadTaxReturnPayload from "@/dto/request/itrq/UploadTaxReturnPayload";
import { processError } from "@/utils/ComponentUtils";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import SelectOption from "@/components/common/SelectOption";

@Component({
  components: { SingleFileHolder, PortalInput, PortalSelect }
})
export default class UploadTaxReturnModal extends Vue {
  @Prop({ required: true })
  private itrqId!: number;

  @Prop({ required: true })
  private year!: string;

  private fileMeta: FileMetaDTO | null = null;

  private payload: UploadTaxReturnPayload = {
    file: 0,
    formId: "",
    category: "FEDERAL",
    year: ""
  };

  get categoryOptions(): SelectOption[] {
    return [
      new SelectOption({ title: "Federal", value: "FEDERAL" }),
      new SelectOption({ title: "State", value: "STATE" })
    ];
  }

  mounted() {
    this.payload.year = this.year;
  }

  get isReady() {
    return this.fileMeta && this.payload.formId && this.payload.category && this.payload.year;
  }

  @Prop()
  private onSuccess?: () => void;

  private upload() {
    this.payload.file = this.fileMeta?.id || 0;
    IndividualTaxationService.uploadTaxReturn(this.itrqId, this.payload).then(
      ok => {
        if (this.onSuccess) {
          this.onSuccess();
        }
        this.$emit("close");
        this.$emit("onSuccess");
        this.$modal.hideAll();
      },
      err => {
        processError(err, this);
      }
    );
  }
}
